const isUrlProtocol = value => {
  return value === 'http://' || value === 'https://';
};
const startsWithUrlProtocol = value => {
  return value.startsWith('http://') || value.startsWith('https://');
};
export const formatUrlValue = (prevValue, currentValue) => {
  if (startsWithUrlProtocol(currentValue)) {
    return currentValue;
  }
  if (isUrlProtocol(prevValue) && currentValue.length < prevValue.length) {
    return '';
  }
  if (prevValue.length === 0 && currentValue.length > 0) {
    return `https://${currentValue}`;
  }
  return currentValue;
};